module.exports = __webpack_public_path__ + "left.2mKT9-VN.svg";